const GraderAbbreviations = [
    { gradingCompanyId: "2750119", abbreviation: "Ace" },
    { gradingCompanyId: "2750129", abbreviation: "AiGrading" },
    { gradingCompanyId: "2750128", abbreviation: "Arena Club" },
    { gradingCompanyId: "2750122", abbreviation: "ARK" },
    { gradingCompanyId: "2750124", abbreviation: "AGS" },
    { gradingCompanyId: "275011", abbreviation: "BCCG" },
    { gradingCompanyId: "275013", abbreviation: "BGS" },
    { gradingCompanyId: "275012", abbreviation: "BVG" },
    { gradingCompanyId: "2750120", abbreviation: "CGA" },
    { gradingCompanyId: "275015", abbreviation: "CGC" },
    { gradingCompanyId: "275014", abbreviation: "CSG" },
    { gradingCompanyId: "2750125", abbreviation: "DSG" },
    { gradingCompanyId: "275018", abbreviation: "GMA" },
    { gradingCompanyId: "2750112", abbreviation: "GSG" },
    { gradingCompanyId: "2750127", abbreviation: "GRAAD" },
    { gradingCompanyId: "275019", abbreviation: "HGA" },
    { gradingCompanyId: "2750110", abbreviation: "ISA" },
    { gradingCompanyId: "275017", abbreviation: "KSA" },
    { gradingCompanyId: "2750126", abbreviation: "Majesty" },
    { gradingCompanyId: "2750114", abbreviation: "MNT" },
    { gradingCompanyId: "2750123", abbreviation: "Other" },
    { gradingCompanyId: "2750113", abbreviation: "PGS" },
    { gradingCompanyId: "2750118", abbreviation: "PCG" },
    { gradingCompanyId: "2750111", abbreviation: "PCA" },
    { gradingCompanyId: "275010", abbreviation: "PSA" },
    { gradingCompanyId: "2750116", abbreviation: "Rare" },
    { gradingCompanyId: "2750117", abbreviation: "RCG" },
    { gradingCompanyId: "275016", abbreviation: "SGC" },
    { gradingCompanyId: "2750115", abbreviation: "TAG" },
    { gradingCompanyId: "2750121", abbreviation: "TCG" },
];

/**
 * Returns the abbreviation for a grader w/ the grade name based on the grader's eBay ID i.e. (PSA 10).
 * If the grader is not known, returns ??? for the abbreviation
 * @param gradingCompanyId eBay's unique ID for the grader
 * @param gradeName the name (NOT ID) of the grade. this will just be appended after the abbreviation
 * @returns 
 */
export const gradedDisplay = (gradingCompanyId: string, gradeName: string | null) => {
    const item = GraderAbbreviations.find(x => x.gradingCompanyId === gradingCompanyId);
    const grade = gradeName ?? 'NO GRADE';

    if (item) {
        return `${item.abbreviation} ${grade}`;
    }

    return `??? ${grade}`
}